/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import usePurchaseOrderService, { PURCHASE_ORDER_TYPES } from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import { usePurchaseOrderUrl, usePurchaseOrderId } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import CreatePurchaseOrderBreadcrumbs from 'domain/finance/purchaseOrder/createupdate/Create/Breadcrumbs';
import PurchaseOrderForm from 'domain/finance/purchaseOrder/createupdate/PurchaseOrderForm';

const CreatePurchaseOrderPage = () => {
  const { create, getValidationSchema, getById } = usePurchaseOrderService();
  const { getSingleEntityUrl } = usePurchaseOrderUrl();
  let getDataFunc;
  const id = usePurchaseOrderId();

  if (id) {
    getDataFunc = async () => {
      const data = await getById(id);

      return {
        type: data.type,
        vendor: data.vendor,
        title: data.title,
        office: data.office,
        account: data.account,
        budgetCategory: data.budgetCategory,
        purchasePurpose: data.purchasePurpose,
        requiredDeliveryDate: data.requiredDeliveryDate,
        expirationDate: data.expirationDate,
        requestor: data.requestor,
        requestorName: `${data.requestor} ${data.requestorFullName}`,
        currency: data.purchases[0].cost?.currency,
        purchases: data.purchases.map(({ name }: any) => ({ name })),
      };
    };
  }

  return (
    <CreateForm
      submitFormFunc={create}
      getDataFunc={getDataFunc}
      afterSubmit={{
        redirect: data => getSingleEntityUrl(data.id),
        message: 'You are awesome! The Purchase Order has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        currency: 'USD',
        purchases: [{}],
        type: PURCHASE_ORDER_TYPES.STANDARD,
      }}
    >
      <CreatePageLayout breadcrumbs={<CreatePurchaseOrderBreadcrumbs />} title="Create: Purchase Order">
        <PurchaseOrderForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreatePurchaseOrderPage;
